import EfSpec from '@elem/ui/ef-spec';
import EfTitle from '@elem/ui/ef-title';
import styles from './index.module.scss';
import { useLang } from '@/i18n';

const imgMain = 'https://websiteoss.ecoflow.com/upload/image/1775273986401/D3.png';
const imgAcCable = 'https://websiteoss.ecoflow.com/upload/image/1725500461530/AC_cable_na.png';

export default function TheComp() {
    const { t } = useLang('delta3series');

    const list = [
        { title: t('N_text1'), pc: imgMain },
        { title: t('N_text2'), pc: imgAcCable },
        { title: t('N_text3'), pc: 'https://websiteoss.ecoflow.com/upload/image/1775273986010/%E8%AF%B4%E6%98%8E%E4%B9%A6%E5%92%8C%E4%BF%9D%E4%BF%AE%E5%8D%A1.png' },
    ];

    return (
        <div className={`${styles.TheComp} GtmModuleData-section`} data-section-id="D3-N" id='D3-N'>
            <EfSpec className="spec-x" />
            <EfTitle>{t('N_title')}</EfTitle>
            <ul className="box-eu">
                {list.map((item, k) => (
                    <li className={`item item-${k + 1}`} key={k} style={{ gridArea: `box-${k + 1}` }}>
                        <div className="item-img">
                            <img src={item.pc} alt={item.title} width={'100%'} height={'100%'} />
                        </div>
                        <div className="item-title">{item.title}</div>
                    </li>
                ))}
            </ul>
        </div>
    );
}
